import React from "react";
import {
  MdNavigateBefore,
  MdNavigateNext,
  MdFirstPage,
  MdLastPage,
} from "react-icons/md";

const Pagination = ({
  currentPage,
  totalPages,
  onFirstPage,
  onPreviousPage,
  onNextPage,
  onLastPage,
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-8 flex items-center justify-center">
      <div className="inline-flex rounded-md shadow-sm">
        <button
          onClick={onFirstPage}
          disabled={currentPage === 1}
          className={`${
            currentPage === 1
              ? "cursor-not-allowed bg-gray-100 text-gray-400"
              : "bg-white text-gray-700 hover:bg-gray-50"
          } inline-flex items-center rounded-l-md border border-gray-300 px-3 py-2 text-sm font-medium`}
          aria-label="Première page"
        >
          <MdFirstPage />
        </button>

        <button
          onClick={onPreviousPage}
          disabled={currentPage === 1}
          className={`${
            currentPage === 1
              ? "cursor-not-allowed bg-gray-100 text-gray-400"
              : "bg-white text-gray-700 hover:bg-gray-50"
          } inline-flex items-center border-b border-r border-t border-gray-300 px-3 py-2 text-sm font-medium`}
          aria-label="Page précédente"
        >
          <MdNavigateBefore />
        </button>

        <div className="flex items-center border-b border-r border-t border-gray-300 bg-white px-4 py-2 text-sm font-medium">
          <span className="mx-2 font-medium text-gray-700">
            Page {currentPage} sur {totalPages}
          </span>
        </div>

        <button
          onClick={onNextPage}
          disabled={currentPage === totalPages || totalPages === 0}
          className={`${
            currentPage === totalPages || totalPages === 0
              ? "cursor-not-allowed bg-gray-100 text-gray-400"
              : "bg-white text-gray-700 hover:bg-gray-50"
          } inline-flex items-center border-b border-r border-t border-gray-300 px-3 py-2 text-sm font-medium`}
          aria-label="Page suivante"
        >
          <MdNavigateNext />
        </button>

        <button
          onClick={onLastPage}
          disabled={currentPage === totalPages || totalPages === 0}
          className={`${
            currentPage === totalPages || totalPages === 0
              ? "cursor-not-allowed bg-gray-100 text-gray-400"
              : "bg-white text-gray-700 hover:bg-gray-50"
          } inline-flex items-center rounded-r-md border-b border-r border-t border-gray-300 px-3 py-2 text-sm font-medium`}
          aria-label="Dernière page"
        >
          <MdLastPage />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
